export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-08.jpg'),
        title: '业务流程外包',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '业务流程外包',
      description: `<p style="font-size:1.05rem">
     当前经济全球化正在进入新的发展阶段,全球产业转移从制造业向服务业延伸,服务业外包成为服务业全球化发展的重要趋势。而企业采用BPO模式，将企业辅助业务转包给专业的且有丰富经验的第三方公司，企业将提升自身主营业务的竞争优势。业务流程外包BPO优势：
      </p>
      <p>
    BPO适用于所有行业、有利于加快企业的发展、
有效地改善辅助业务对核心业务的支持作用，增加整体赢利、
企业进一步突出对核心业务的重点管理，同时实现对辅助业务的有效控制、
有利于在新的市场环境中打破传统的行业界线，与外部公司形成跨业务领域的联合，构成长期的战略伙伴关系，增强彼此的竞争力、
有利于控制和降低企业的生产成本。
      </p>`
    },
    {
      title: '我们的服务和优势',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-08.jpg')+`)"></span>
      <span class="list">
      <i></i>长期积累的外包服务经验，可以根据客户的实际情况，结合国家政策，制定适合客户的最佳方案。<br/>
      <i></i>全面提升管理效能<br/>
      <i></i>协助企业进行成本控制<br/>
      <i></i>协助企业提升自身的核心业务能力<br/>
      </span>`
    }
  ]
}
